module.exports = __webpack_public_path__ + "static/img/logo.f216cb7a.png";